const playerOptions = {
    controls: true,
    // shows alternative controls for touch devices
    // but hides the default controls
    // nativeControlsForTouch: true,
    playsinline: true,
    muted: true,
    preload: 'auto',
    aspectRatio: '16:9',
    fluid: true,
    autoSetup: false,
    liveui: true,
    liveTracker: {
        trackingThreshold: 20,
        liveTolerance: 15,
    },
    playbackRates: [0.1, 0.25, 0.5, 1, 1.5, 2],
    controlBar: {
        fullscreenToggle: false,
        pictureInPictureToggle: false,
        skipButtons: {
            forward: 10,
            backward: 10,
        },
    },
    userActions: {
        click: true,
    },
    spatialNavigation: {
        enabled: true,
        horizontalSeek: true,
    },
};

const playerOverlayOptions = {
    controls: false,
    muted: true,
    preload: 'auto',
    aspectRatio: '16:9',
};
